<template>
  <div class="container">
    <!-- 老用户收集信息时不显示 -->
    <w-navbar
        v-show="(iosOrAndroidShow && !isOldUserInfoCollect)"
        :icon="newUser ? '' : 'iconchevron-left'"
        :cvShow="true"
        @mobileLeftBtn="leftBtnClick"/>

    <div v-if="newUser" class="progressBar">
      <WProgressBar width="70%" />
    </div>
    <!-- 老用户收集信息时不显示 -->
    <template v-if="!isOldUserInfoCollect"> 
      <div class="choose-title">{{ newUser ? 'Hi 初次见面！' : '请选择您当前的身份' }}</div>
      <div class="reminder">{{ newUser ? '大大方方地介绍下自己吧～' : '您可以在求职设置中修改您的求职偏好' }}</div>

      <div class="gender-box" :class="{'show-basic-info': isShowBasicInfo}">
        <div class="gender-btn male-btn"  :class="{'active':  nowGender === 'male'}" @click="setGender('male')">
          <i class="iconfont iconnan"></i>
          <span>男生</span>
        </div>
        <div class="gender-btn female-btn" :class="{'active':  nowGender === 'female'}" @click="setGender('female')">
          <span>女生</span>
          <i class="iconfont iconnv"></i>
        </div>
      </div>
    </template>
    <!-- 老用户要显示信息 -->
    <div v-if="isOldUserInfoCollect" class="old-user-info-layout">
      <div class="old-user-info-child">
        <div class="old-user-info-title">{{ '提升求职效率' }}</div>
        <i class="iconfont iconx" style="font-size: 24px" @click="leftBtnClick()"></i>
      </div>
      <div class="old-user-info-desc">{{ '更新求职状态、意向岗位，为你精准匹配简历模板、高薪职位，求职效率翻倍' }}</div>
    </div>

    <template v-if="!isShowBasicInfo">
      <div v-for="item in identity" :key="item.key" :class="['option', `option_${item.key}`]" @click="chooseIdentity(item.status)" data-growing-container>
        <div class="option-content">
          <div>
            <p class="type">{{item.name}}</p>
            <p class="other">{{item.other}}</p>
          </div>
        </div>
        <img class="option-img" :src="`https://files.wondercv.com/intention/${nowGender}-${item.type}.png`" alt="">
      </div>
    </template>

     <!-- 新注册用户要显示的基本信息 -->
    <template v-if="newUser && isShowBasicInfo">
      <div class="basic-info">
        <!-- 身份信息 -->
        <div class="identity-layout">
          <div v-for="item in [{key: 0, index: 1},{key: 1, index: 0}]" :key="item.key" class="identity-item" 
            :class="{active: currentIdentity === identity[item.index].status}" @click="chooseIdentity(identity[item.index].status)">
            <p class="identity-item-title">{{ identity[item.index].name }}</p>
            <img class="identity-item-img" :src="`https://files.wondercv.com/intention/img_${currentIdentity === identity[item.index].status? 'selected' : 'unselected'}_${nowGender}_${identity[item.index].type}.png`" alt="">
          </div>
        </div>
        <!-- 填写基本信息 -->
        <div>
          <div v-for="(item, index) in basicInfos" :key="item.key" class="content-item">
            <p class="text-title">{{item.name}}</p>
            <div class="content-child" @click="onBasicInfoItemClick(item)">
              <p class="text-desc" :class="{active: currentSelectedDegree.length > 0}" v-if="index === 0">{{ currentSelectedDegree[0] || item.placeholderText }}</p>
              <p class="text-desc" :class="{active: currentSelectedSchool.name}" v-if="index === 1">{{ currentSelectedSchool.name || item.placeholderText }}</p>
              <p class="text-desc" :class="{active: currentSelectedYear}" v-if="index === 2">{{ currentSelectedYear || item.placeholderText }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="next-btn" @click="onSubmitInfo">
        <img class="next-btn-img" src="https://files.wondercv.com/intention/ic_white_right_arrow.png" alt="">
      </div>
    </template>

    <w-popup :state="isShowPickerSchool" @handleClose="isShowPickerSchool=false">
      <picker-school slot="content" v-if="isShowPickerSchool" @receiveSchoolItem="receiveSchoolItem" @handleClose="isShowPickerSchool=false"/>
    </w-popup>
  </div>
</template>

<script>
  import WNavbar from "@/components/global/w-navbar";
  import WProgressBar from "@/components/global/w-progress-bar";
  import WPopup from "@/components/global/w-popup";
  import PickerSchool from "./components/picker-school";
  import intention from "@/api/api-list/intention";
  import Cookies from "js-cookie";
  import {envMixin} from "@/assets/js/mixin/global";
  import {userMixin} from "@/assets/js/mixin/user";
  import {mapState, mapActions, mapMutations} from "vuex";
  import { componentsMixin } from '@/assets/js/mixin/components';
  import {toLogin} from "@/assets/js/utils";
  import { eduForm } from "@/assets/json/online-cv";

  const DEGREE_IDS = new Map([["中专", 6], ["高中", 7], ["大专", 1], ["本科", 2], ["硕士", 3], ["博士", 4], ["MBA", 5]]);

  export default {
    name: "template-matches",
    mixins: [ envMixin, componentsMixin, userMixin],
    data() {
      return {
        identity: [
          {
            key: 1,
            name: "学生党",
            status: "student",
            other: "学生找实习或全职工作",
            type: "student"
          },
          {
            key: 2,
            name: "职场人",
            status: "already_work",
            other: "想要换工作的职场人士",
            type: "work"
          }
        ],
        basicInfos: [
          {
            key: 1,
            name: "最高学历",
            placeholderText: "请选择最高学历",
            type: "degree"
          },
          {
            key: 2,
            name: "学校名称",
            placeholderText: "填写学校名称，校友助你高效求职",
            type: "school"
          },
          {
            key: 3,
            name: "毕业时间",
            placeholderText: "选择毕业时间，精准匹配简历模板",
            type: "time"
          }
        ],
        nowGender: 'male', // 当前性别 默认性别：男
        newUser: false, // 是否是新用户
        currentIdentity: null, // 当前身份, 默认为 null
        isShowBasicInfo: false, // 是否显示基本信息，true显示，默认false
        isOldUserInfoCollect: false, // 是否为老用户信息收集
        currentYear: new Date().getFullYear(), // 当前年份，比如 2021
        timePickerData: [], // 年份picker数据源
        isShowPickerSchool: false, // 是否显示学校选择器
        currentSelectedDegree: [], // 用户所选择的学历
        currentSelectedSchool: {}, // 用户所选择的学校
        currentSelectedYear: "", // 用户所选择的年份
      };
    },
    computed: {
      ...mapState('user', ['userData', 'isNewUser', 'cacheSelectedDegree', 'cacheUserIdentity', 'cacheSelectedSchool', 'cacheSelectedYear']),
      // 如果noIcon有值，则是新用户注册
    	// noIcon () {
    	// 	return this.$route.query.notIcon
      // }
    },
    async created () {
      await this.getUserData()
      let { isOldUserInfoCollect } = this.$route.query
       // 如果is_student值为null，说明是新用户
      if (this.userData.is_student === null) this.newUser = true
      if (this.isNewUser) {
        this.newUser = true;
        this.isShowBasicInfo = true;
        this.currentIdentity = this.cacheUserIdentity;
        this.currentSelectedDegree = this.cacheSelectedDegree;
        this.currentSelectedSchool = this.cacheSelectedSchool;
        this.currentSelectedYear = this.cacheSelectedYear;
        this.clearNewUserInfo();
      }
      if (this.userData.gender === '女') this.nowGender = 'female'
      if (this.userData.gender === '男') this.nowGender = 'male'
      if (isOldUserInfoCollect) this.isOldUserInfoCollect = isOldUserInfoCollect
      if (this.newUser) { // 新用户
        this.generteYears();
        this.$db.ls.set(`${this.cvAccountToken}-newUserLoginTime`, {newAccount: true, loginTime: new Date().getTime()});
      }
    },
    watch: {},
    components: {
      WNavbar,
      WProgressBar,
      WPopup,
      PickerSchool
    },
    methods: {
      ...mapActions('user', ['getUserIntention']),
      ...mapMutations('user', ['clearNewUserInfo']),
      leftBtnClick() {
        this.$router.back();
      },
      chooseIdentity(key) {
        this.currentIdentity = key; // 当前身份
        if (this.newUser) {
          this.isShowBasicInfo = true;
        } else {
          this.onSubmitInfo();
        }
      },
      onSubmitInfo() {
       
        let params = {
          gender: this.nowGender === 'male' ? '男' : '女'
        }
        let identityParams = {status: this.currentIdentity};
        if (this.newUser) { // 新用户可以提交附加参数 （学历、学校、毕业时间）
          // 学历
          if (this.currentSelectedDegree.length > 0) {
            identityParams['cust_degree'] = this.currentSelectedDegree[0];
            identityParams['degree_id'] = DEGREE_IDS.get(this.currentSelectedDegree[0]);
            identityParams['edu_type'] = this.currentSelectedDegree[1];
          }
          // 学校
          if (this.currentSelectedSchool.name) {
            identityParams['cust_uni_name'] = this.currentSelectedSchool.name;
          }
          if (this.currentSelectedSchool.id) {
            identityParams['university_id'] = this.currentSelectedSchool.id;
          }
          // 毕业时间
          if (this.currentSelectedYear) {
            identityParams['graduate_at'] = `${this.currentSelectedYear}-01-01`;
          }
        }
        console.log(identityParams);
        Promise.all([ 
          intention.chooseIdentity(this.cvAccountToken, identityParams),
          this.$api.online.createBasicInfo(params, this.cvAccountToken)
        ]).then(resp => {

          if (resp[0].code == 1000) {
            this.getUserIntention()
            if (this.newUser) {
              // this.$router.push("/account/expect-work");
              this.$router.push({path: '/template_matches/user-current-state', 
              query:{ identity: this.currentIdentity, 
                    degree: this.currentSelectedDegree, 
                    school: this.currentSelectedSchool, 
                    year: this.currentSelectedYear }});

            } else if (this.currentIdentity === 'student') {
              this.$router.push("/account/student-work-type");
            } else {
              this.$router.push("/account/worker-state");
            }
          } else if(resp[0].code === 2001) {
            this.showToast(resp[0].message);
            setTimeout(() => {
              if (this.WxMixin) {
                this.$wechat.miniProgram.redirectTo({
                  url: `/pages/login/login`
                })
              } else {
                Cookies.remove('_t', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
                Cookies.remove('_t_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
                Cookies.remove('_t_plugin', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
                Cookies.remove('_t_plugin_at', { domain: window.location.href.replace(/.*(\.wondercv\.(cn|com)).*/gim, '$1') });
                toLogin(process.env.VUE_APP_HOST + '/account/users/index');
              }
            }, 1000)
          } else {
            this.showToast(resp[0].message);
          }
          
        }).catch(error => {
          console.log(error)
        })
      },
      // 设置性别
      setGender (val) {
        this.nowGender = val
      },
      // 基本信息条目点击事件
      onBasicInfoItemClick(item) {
        if (item.type === "degree") { // 学历
          this.clickDegree();

        } else if (item.type === "school") { // 学校
          //this.clickSchool();
          this.isShowPickerSchool = true; // 显示学校选择器
        } else if (item.type === "time") { // 毕业时间
          this.clickTime();
        }
      },

      clickDegree() {
       if (!this.degreePicker) { 
          this.degreePicker = this.$createPicker({
          data: eduForm[2].pickerData,
          selectedIndex: [[2], [0]],
          onSelect: (resultArr) => {
            console.log(resultArr);
            this.currentSelectedDegree = [];
            this.currentSelectedDegree = resultArr;
          },
            // onCancel: this.cancelHandle
          })
        }
        this.degreePicker.show();
      },

      clickSchool() {
        this.$router.push('/template_matches/user-current-state')
      },
      clickTime() {
       if (!this.timePicker) {
          let defaultIndex = this.timePickerData.findIndex((item) => item.value === this.currentYear);
          this.timePicker = this.$createPicker({
            data: [this.timePickerData],
            selectedIndex: [defaultIndex],
            onSelect: (resultArr) => {
              console.log(resultArr);
              this.currentSelectedYear = resultArr[0];
            }
          })
        }
       this.timePicker.show();
      },
      // 生成年份数据源
      generteYears() {
        // 生成1900~当前年份+10。因为默认从零开始，所以这里得加11
        let years = Array.from(new Array(this.currentYear + 11).keys()).slice(1900);
        years.forEach(item => {
          this.timePickerData.push({text: item, value: item});
        })
      },
      // 接收所选择的学校
      receiveSchoolItem(school) {
        console.log("school item=>", school);
        this.currentSelectedSchool = school;
        this.isShowPickerSchool = false; // 隐藏学校选择器
      }
    }
  };
</script>

<style lang="scss" scoped>
  .container {
    .progressBar {
      width: 100%;
      position: absolute;
      top: 16px;
      z-index: 100;
      padding: 0 24px;
    }

    .choose-title {
      padding: 70px 0 8px 24px;
      font-size: 24px;
      color: #404040;
      font-weight: 600;
    }

    .reminder {
      padding: 0 0 0 24px;
      color: #9C9C9C;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 43px;
    }

    .gender-box {
      display: flex;
      padding: 0 24px;
      margin-bottom: 53px;
      &.show-basic-info {
          margin-bottom: 30px;
      }
      .gender-btn {
        width: 77px;
        height: 32px;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #9C9C9C;
        box-shadow: 0px 2px 18px 0px rgba(5, 32, 82, 0.08);
        // margin-bottom: 53px;
        >i {
          font-size: 12px;
        }
      }

      .male-btn {
        border-radius: 8px 0px 0px 8px;
        >i {
          margin-right: 7px;
          color: #4183FF;
        }
        &.active {
          background: #4183FF;
          color: #fff;
          >i {
            color: #fff;
          }
        }
      }

      .female-btn {
        border-radius: 0px 8px 8px 0px;
        >i {
          margin-left: 7px;
          color: #FF6644;
        }
        &.active {
          background: #FF6644;
          color: #fff;
          >i {
            color: #fff;
          }
        }
      }
    }

    .option {
      width: 327px;
      height: 100px;
      background: #ffffff;
      box-shadow: 0px 2px 18px 0px rgba(5, 32, 82, 0.08);
      border-radius: 8px;
      margin-left: 24px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-left: 24px;
    }

    .option-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1
    }

    .type {
      color: #404040;
      font-size: 16px;
      margin-bottom: 10px;
      font-weight: 500;
    }

    .other {
      color: #9C9C9C;
      font-size: 12px;
      font-weight: 400;
    }

    .option-img {
      width: 147px;
    }

    .old-user-info-layout {
      // padding-right: 24px;
      padding: 50px 24px 43px 24px;
      line-height: 20px;
      .old-user-info-child {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
      .old-user-info-title {
        font-size: 24px;
        color: #404040;
        font-weight: 600;
        padding-bottom: 8px;
      }
      .old-user-info-desc {
        padding: 0 0 0 0;
        color: #9C9C9C;
        font-size: 14px;
        font-weight: 400;
      }
    }
    
    .basic-info {
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      margin-top: 0;
      .identity-layout {
        display: flex;
        flex-direction: row;
        .identity-item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          height: 60px;
          background: #F9F9F9;
          border-radius: 8px;
          padding: 0 0 0 16px;
          &.active {
            background: #FFFFFF;
            box-shadow: 0px 2px 18px 0px rgba(5, 32, 82, 0.08);
          }
          .identity-item-img {
            width: 83px;
            height: 60px;
          }
          .identity-item-title {
            color: #404040;
            font-size: 16px;
            font-weight: 500;
          }
        }
        .identity-item:nth-last-child(1) {
          margin-left: 15px;
        }
      }
      .content-item {
        margin-top: 24px;
        border-bottom: 1px solid #F9F9F9;
        .text-title {
          color: #606060;
          font-size: 12px;
        }
        .content-child {
          padding: 8px 0px;
          .text-desc {
            color: #CFCFCF;
            font-size: 15px;
            &.active {
              color: #404040;
              font-weight: 500;
            }
          }
        }
      }
      .content-item:first-child {
        margin-top: 36px;
      }
    }

    .next-btn {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      bottom: 0;
      right: 0;
      margin: 0 24px 24px 0;
      width: 64px;
      height: 64px;
      border-radius: 32px;
      background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
      box-shadow: 0px 6px 24px -8px #FF6644;
      .next-btn-img {
        width: 12px;
        height: 20px;
      }
    }
  }
</style>
